var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('user-step',{attrs:{"step":_vm.step,"statePart":_vm.statePart,"in-progress":_vm.businessSolutionInProgress},on:{"createUser":_vm.createBookingChannelAdmin}})}
var staticRenderFns = []

export { render, staticRenderFns }